// extracted by mini-css-extract-plugin
export var quantityInput = "_of-0";